import React from 'react';
import { useFieldHelper } from 'framework/ui/field';
import { Badge } from 'framework/ui/mui-builder';

const IncidentCountField = (props: any) => {
  const { getValue } = useFieldHelper(props);
  const count = getValue();
  const badgeColor = count ? 'error' : 'success';

  return <Badge color={badgeColor}>{count}</Badge>;
};

export default IncidentCountField;
